import { mapProps } from '@lib/connect';
import { sha1 } from '@lib/hash';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

/**
 * useReduxState hook, useful react hook to grab state using same props definition as `connect` function
 * @example
 * const partialState = useReduxState({
 *      authenticated: 'Auth.authenticated'
 * });
 *
 * console.log(partialState.authenticated);
 * @param props
 * @returns {any}
 */
export function useReduxState(props: any): { [key: string]: any } {
    const stateGetter = useCallback(mapProps(props) as any, [sha1(props)]);

    return useSelector(stateGetter);
}
